import React from 'react';

import { QueryResult, useQuery } from '@betterment/js-runtime';

import { urlBuilder } from '../../Shared/urlBuilder';
import { BankDocument } from '../data';

type BankDocumentsContextType = QueryResult<BankDocument[]>;

export const BankDocumentsContext = React.createContext<BankDocumentsContextType | null>(null);

const BankDocumentProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const queryResult = useQuery<BankDocument[]>(urlBuilder.getBankDocuments());
  return <BankDocumentsContext.Provider value={queryResult}>{children}</BankDocumentsContext.Provider>;
};

export const useBankDocuments = () => {
  const context = React.useContext(BankDocumentsContext);
  if (!context) {
    throw new Error('useBankDocuments must be used under BankDocumentsProvider');
  }
  return context;
};

export default BankDocumentProvider;
